import React, { ChangeEvent } from 'react'
import classNames from 'classnames'
import { Form } from 'react-bootstrap'
import { WidgetProps } from '@rjsf/utils'

import './../formFills.scss'
import { CustomWidgetProps } from '../FormCitation/FormCitation'

export const CustomCheckboxWidget: React.FC<WidgetProps> = (props) => {
  const { value, onChange, disabled } = props
  const { isEditing, fieldContainerClass, citationButton } = props.options as CustomWidgetProps
  const handleChange = (e: ChangeEvent<HTMLInputElement>) => {
    onChange(e.target.checked)
  }

  const checkbox = <Form.Check className='d-flex contact-information-checkbox' type='checkbox' checked={value} onChange={handleChange} disabled={disabled} />

  return isEditing || value !== null ? (
    <div className={classNames(fieldContainerClass, 'w-100')}>
      {isEditing ? (
        checkbox
      ) : (
        <>
          <div
            className={classNames('form-control border-0 d-flex align-items-center flex-grow-1', {
              'disabled-contact-information-field': disabled,
            })}
          >
            {checkbox}
          </div>
          {value ? <div className='flex-shrink-0'>{citationButton}</div> : null}
        </>
      )}
    </div>
  ) : (
    <Form.Control
      type='text'
      placeholder='No relevant information detected'
      className='form-control border-0 disabled-contact-information-field'
      disabled={true}
    />
  )
}
